import { render } from "./SIPServer.vue?vue&type=template&id=1e2ec72f&scoped=true"
import script from "./SIPServer.vue?vue&type=script&lang=js"
export * from "./SIPServer.vue?vue&type=script&lang=js"

import "./SIPServer.vue?vue&type=style&index=0&id=1e2ec72f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e2ec72f"

export default script